import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const wrap = css`
  max-width: ${width.container.wider};
  text-align: center;
  margin-inline: ${size[24]};

  ${breakpoint.up('md')} {
    margin-inline: auto;
    margin-bottom: ${size[64]};
  }
`

export const title = (theme: Theme) => css`
  font-size: ${pxToRem(28)};
  font-weight: 700;
  margin-bottom: ${size[32]};
  line-height: ${pxToRem(32)};
  color: ${theme.palette.text.title};

  ${breakpoint.up('smMd')} {
    line-height: 100%;
    font-size: ${pxToRem(48)};
    margin-bottom: ${size[80]};
  }

  span {
    color: ${theme.palette.primary.mainContrast};
  }
`

export const box = (theme: Theme) => css`
  display: flex;
  background-color: ${theme.palette.background.accent};
  color: ${theme.palette.text.titleReversed};
  border-radius: ${theme.borderRadius.lg};
  max-height: 280px;
  justify-content: center;

  ${breakpoint.up('md')} {
    justify-content: space-between;
  }
`

export const contacts = css`
  list-style-type: none;
  margin: 0;
  padding: ${size[24]} ${size[16]};
  align-self: center;
  display: grid;
  grid-template-columns: 50% 50%;
  gap: ${size[16]};

  ${breakpoint.up('md')} {
    grid-template-columns: 1fr 1fr 1fr;
    gap: ${size[32]};
    padding: 0 0 0 ${size[40]};
  }
`

export const img = css`
  display: none;
  height: 390px;
  width: 390px;
  position: relative;
  top: -45px;
  margin-inline-end: ${size[40]};

  ${breakpoint.up('md')} {
    display: block;
  }
`

export const link = (theme: Theme) => css`
  color: ${theme.palette.text.body};
  display: flex;
  gap: ${size[16]};
  align-items: center;
  font-weight: 500;
  font-size: ${size[16]};
  padding: ${size[8]};
  text-decoration: none;
  text-wrap: nowrap;

  ${breakpoint.up('md')} {
    gap: ${size[24]};
    font-size: ${pxToRem(26)};
    padding: ${size[18]};
  }
`
